import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { getProffitSearchWarningMemberExpireApproach, PROFFIT_SEARCH_WARNING_EXPIRE_APPROACH, PROFFIT_SEARCH_WARNING_FREE_ACCOUNT, } from '../../../define/consts/proffit_search/proffit_search_service';
import { propShape } from '../../../helpers/custom-prop-types';
import { getProffitSearchValues } from '../../../helpers/profile';
import WarningIcon from '../../Icon/Svg/WarningIcon';
const AccountWarning = (props) => {
    const { profile } = props;
    const messages = useMemo(() => {
        const warnings = [];
        const { freeAccountCount, isExpireApproach, memberExpireApproachCount } = getProffitSearchValues(profile);
        if (isExpireApproach) {
            warnings.push({
                key: 'isExpireApproach',
                value: PROFFIT_SEARCH_WARNING_EXPIRE_APPROACH,
            });
        }
        if (memberExpireApproachCount > 0) {
            warnings.push({
                key: 'hasMemberExpireApproach',
                value: getProffitSearchWarningMemberExpireApproach(memberExpireApproachCount),
            });
        }
        if (freeAccountCount > 0) {
            warnings.push({
                key: 'hasFreeAccount',
                value: PROFFIT_SEARCH_WARNING_FREE_ACCOUNT,
            });
        }
        return warnings;
    }, [profile]);
    if (messages.length <= 0) {
        return null;
    }
    return (_jsxs(Link, Object.assign({ className: 'warning_account', to: '/proffit_search/account_list' }, { children: [_jsx("div", Object.assign({ className: 'warning_account_left_wrapper' }, { children: messages.map((message) => (_jsxs("div", Object.assign({ className: 'warning_account_left' }, { children: [_jsx(WarningIcon, {}), _jsx("p", Object.assign({ className: 'warning_account_text' }, { children: message.value }))] }), message.key))) })), _jsx("p", Object.assign({ className: 'warning_account_link' }, { children: "\u30A2\u30AB\u30A6\u30F3\u30C8\u7BA1\u7406\u3078" }))] })));
};
AccountWarning.propTypes = {
    profile: propShape().isRequired,
};
export default AccountWarning;
